import { Component, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit, signal  } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  standalone:false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements AfterViewInit{

  @ViewChild('phoneInput') phoneInput: ElementRef | undefined;

  errors: any = "";

  // Password viewing function
  hide = signal(true);
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.preventDefault();
    // event.stopPropagation();
  }

  // Trigger login from Enter key
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.login();
    }
  }
 
  loginForm = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });
  isLogin: boolean = true;
  isLoading = false;
  errorData: any;
  constructor(private fb: FormBuilder, 
    private apiService: ApiService, 
    private storage: StorageService, 
    private cdr: ChangeDetectorRef, 
    public router: Router,
    public authService: AuthService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,private route: ActivatedRoute) {
    this.apiService.isLogin.subscribe((data) => {
      this.isLogin = data;
    });
  }
  login() {
    if (this.loginForm.valid) {
      this.errors = "";
      this.isLoading = true;
      const details = {
        'phoneoremail': this.loginForm.value.username,
        'password': this.loginForm.value.password
      };
      this.apiService.login(details).subscribe({
          next: (data: any) => {
            if (data.success === true) {
              this.storage.set('user_phone', this.loginForm.value.username!.toString());
              this.isLoading = false;
              this.storage.set('token', data.data.token);
              this.storage.set('user_data', JSON.stringify(data));
              this.authService.isAuthenticated.next(true);
              this.snackBar.open(data.message, '', {
                duration: 2000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: 'text-center'
              });
              // this.router.navigateByUrl('/dashboard', { replaceUrl: true });

              // Get the returnUrl or default to the dashboard
              const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/dashboard';
              this.router.navigateByUrl(returnUrl, { replaceUrl: true });
             
            }else{
              this.errorData = data.message;
              this.snackBar.open(this.errors, '', {
                duration: 2000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: 'center'
              });
            }
          },
          error: (err: any) => {
            console.log("Login api call failed")
            this.isLoading = false;
            this.errors = err.error.messages;
          },
          complete: () => { }
        }
      );
    }

  }
  goToRegister() {
    this.apiService.isLogin.next(false);
  }

  goToSignUp() {
    this.spinner.show();
    this.router.navigate(['/sign-up']);
    this.spinner.hide();
  }

  ngAfterViewInit() {
    if (this.phoneInput) {
      this.phoneInput.nativeElement.focus();
    }
  }
}
